import { ReactComponentManifest } from "web/entrypoints/common/setup";
import AdsenseDisplay from "web/react/components/adsense-display/adsense-display";
import AdsenseShopping from "web/react/components/adsense-shopping/adsense-shopping";
import BrandAdContainer from "web/react/components/brand-ad-container/brand-ad-container";
import CuratedAds from "web/react/components/curated-ads/curated-ads";
import FeedCountAndSort from "web/react/components/feed-count-and-sort/feed-count-and-sort";
import FeedGrid from "web/react/components/feed-grid/feed-grid";
import { FeedHeader } from "web/react/components/feed-header/feed-header";
import FeedsSeoContent from "web/react/components/feeds-seo-content/feeds-seo-content";
import FeedsSeoProfileContents from "web/react/components/feeds-seo-content/feeds-seo-profile-content";
import { FeedsShowMore } from "web/react/components/feeds-show-more/feeds-show-more";
import FilterContainerTop from "web/react/components/filter-container-top/filter-container-top";
import FilterContainer from "web/react/components/filter-container/filter-container";
import { FilterRedesign } from "web/react/components/filter-redesign/filter-redesign";
import ProductCardSendToAppModal from "web/react/components/product-card-send-to-app-modal/product-card-send-to-app-modal";
import ProductsCarousel from "web/react/components/products-carousel/products-carousel";
import RecentlyViewed from "web/react/components/recently-viewed/recently-viewed";
import RelatedRail from "web/react/components/related-rail/related-rail";
import RelatedSearchesRail from "web/react/components/related-searches-rail/related-searches-rail";
import TaxonomyLinks from "web/react/components/taxonomy-links/taxonomy-links";
import { RelatedProductsPage } from "web/react/pages/related-products-page/related-products-page";
import { SearchPage } from "web/react/pages/search-page/search-page";
import withRedux from "web/react/redux-provider";

const components: ReactComponentManifest = {
    AdsenseDisplay: withRedux(AdsenseDisplay),
    AdsenseShopping: withRedux(AdsenseShopping),
    CuratedAds,
    FeedsSeoContent,
    FeedsSeoProfileContents,
    FeedsShowMore: withRedux(FeedsShowMore),
    FilterContainer: withRedux(FilterContainer),
    FilterContainerTop: withRedux(FilterContainerTop),
    ProductCardSendToAppModal: withRedux(ProductCardSendToAppModal),
    FeedHeader: withRedux(FeedHeader),
    ProductsCarousel,
    RecentlyViewed,
    RelatedRail,
    RelatedSearchesRail,
    FeedCountAndSort: withRedux(FeedCountAndSort),
    FeedGrid: withRedux(FeedGrid),
    FilterRedesign: withRedux(FilterRedesign),
    TaxonomyLinks,
    BrandAdContainer,
    SearchPage: withRedux(SearchPage),
    RelatedProductsPage: withRedux(RelatedProductsPage),
};

export default components;
